import { render, staticRenderFns } from "./ForgetPwd.vue?vue&type=template&id=057f58ef&scoped=true"
import script from "./ForgetPwd.vue?vue&type=script&lang=js"
export * from "./ForgetPwd.vue?vue&type=script&lang=js"
import style0 from "./ForgetPwd.vue?vue&type=style&index=0&id=057f58ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057f58ef",
  null
  
)

export default component.exports